<template>
  <el-config-provider :locale="elementLocale" :zIndex="3000" v-if="isAuth">
    <el-container>
      <el-header style="display: flex;  justify-content: center; width: 100%; border-bottom: solid 1px var(--el-menu-border-color)">
        <el-menu class="el-menu-tools" mode="horizontal" :ellipsis="false" :router="true" style="max-width: 1200px; width: 100%; border: none;">
          <el-menu-item index="/">
            <img
              :src="`${apiUrls.dutypay}/api/v0/assets/logo/dutypay/standard/dark/svg`"
              :alt="applicationVariable"
              class="header-bar__application-logo speak-never"
              style="height: 40px; padding: 10px; width: auto"
            />
            <h2>&nbsp;Tools</h2>
          </el-menu-item>
          <div class="flex-grow"></div>
          <el-sub-menu index="/tools">
            <template #title>Tools</template>
            <el-menu-item index="/tools/oss-correction">OSS Correction</el-menu-item>
            <el-menu-item index="/tools/contract-data-confirmations">Vertragsdaten Bestätigungen</el-menu-item>
            <el-menu-item index="/tools/business-actions">Geschäftsvorgangsdaten</el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-header>
      <el-main style="width: 100%; max-width: 1200px; margin: 0 auto; padding: 3rem;">
        <router-view />
      </el-main>
    </el-container>
  </el-config-provider>
</template>

<script setup>
import { onBeforeMount, computed } from "vue";
import { ElConfigProvider } from "element-plus";
import { useAuthStore, useEnvStore } from "@dutypay/store-modules";
import elementLocales from "@dutypay/components-library/src/locales/element-plus";
import { useI18n } from "vue-i18n";
import 'vue3-flag-icons/styles'
//import {menuItems} from './pages.js';

const authStore = useAuthStore();
const envStore = useEnvStore();
const isAuth = computed(() => {
  return authStore.status === "success";
});
//const companyStore = useCompanyStore();
//const ReminderSelectCompany = defineAsyncComponent(() => import('@dutypay/settings-pages/src/reminder/ReminderSelectCompany'))

const { locale } = useI18n({ useScope: "global" });
const elementLocale = computed(() => {
  return elementLocales[locale.value];
});

async function initApp() {
  envStore.setGlobalLoading();
  await envStore.fetchHosts();
  await authStore.tokenAuth();
  await envStore.getDebug();
  //await companyStore.initCompanyStore()
  envStore.releaseGlobalLoading();
}

onBeforeMount(async () => {
  await initApp();
});
</script>

<script>
import { mapState } from "pinia";
export default {
  computed: {
    ...mapState(useEnvStore, ["apiUrls"]),
  },
  methods: {},
  async mounted() {},
};
</script>

<style lang="scss">
$--color-primary: #5392bc;
@import "~@dutypay/design-system/src/scss_legacy/index.scss"; // TODO: Legacy scss. Can be removed when the last relicts of element are gone.

.flex-grow {
  flex-grow: 1;
}

</style>

<i18n>
{}
</i18n>
